export default {
  footer: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}
